//Initialize default state for product listings
const getDefaultState = () => {
  return {
    content: {
      ListProducts: {
        title:
          "Kemikalieinspektionen offentliggør overtrædelser af kemikalielovgivningen",
        subTitle:
          "Vil du følge med, når Kemikalieinspektionen håndhæver overtrædelser af kemikalielovgivningen?",
        description:
          "<p>Kemikalieinspektionen behandler løbende sager om produkter, kemikalier eller blandinger, \
          som nogle gange viser sig ikke at overholde loven. Her på siden kan du se de sager, hvor \
          Inspektionen har fundet lovovertrædelser.</p><p>\
          Inspektionen kan have indskærpet forholdet overfor en impliceret virksomhed, \
          men kan også have meddelt dem både påbud og forbud.</p>\
          <p>Det blev muligt for Inspektionen at offentliggøre sagerne pr. 1. juli 2021, og Inspektionen \
          gør brug af muligheden, når det tjener et forbruger- eller miljøhensyn, eller hvis det i øvrigt \
          vurderes at være proportionelt med overtrædelsen. Du vil for de enkelte sager kunne se, \
          hvorfor Inspektionen har håndhævet i sagen og hvilken regel, der er overtrådt.</p>\
          <p>Nogle af Inspektionens sager kan af juridiske årsager ikke offentliggøres, og derfor er \
          det ikke alle lovovertrædelser, der fremgår af denne side.</p>\
          <p>En sag vil fremgå på siden i op til to år efter Inspektionen har offentliggjort den.</p>\
          <p>Er du bekendt med et produkt, som du mener er farligt eller ulovligt på grund af kemi? \
          Så anmeld det til Kemikalieinspektionen via linket i højre side.</p>",
        backToTopBtnText: "Gå til top",
        placeholderSearch: "Søg",
        filterReactionTitle: "Filtrér på håndhævelsesniveau",
        filterCategoryTitle: "Filtrér på produktkategori",
        clearFiltersTitle: "Ryd filtre",
        saveFiltersTitle: "Gem filtre",
        filterModalTitle: "Filtrér",
        noSearchResults: {
          title: "Vi fandt ingen",
          subTitle: "for din søgning på",
          body: "<p>Din søgning i listen over sager gav intet resultat!</p>",
        },
        readMoreCategories: "Læs mere om kategorierne her",
        noCategoryDescription:
          "Der er ikke nogen beskrivelse til denne kategori på nuværende tidspunkt. Vi arbejder på at løse dette.",
      },
      ProductInfo: {
        guideline:
          "Hvis du vil vide mere om, hvordan du skal forholde dig som forbruger, \
          kan du tage kontakt til den ansvarlige virksomhed.",
        viewMoreProducts: "Se lignende sager her",
        caseDevelopment: "Hvad er der sket i denne sag?",
        reasonsTitle: "Hvad er der galt?",
        detailsTitle: "Sagens detaljer",
        furtherInfoTitle: "Yderligere information",
        goBackToListView: "Gå tilbage til listevisningen",
      },
    },
    scrollToList: false,
    page: 1,
    productsPerPage: 18,
    totalNumberProducts: 0,
    searchTerm: "",
    filtersInput: {
      reactionFilters: [],
      categoryFilters: [],
    },
    productCard: {},
    productCards: {},
    carouselCards: {},
    reactionNames: {},
    categoryNames: {},
    productImageDict: {},
    categoryImages: [
      {
        category: "pesticider",
        fileName: "Pesticider.jpg",
        description:
          "<p>Her på siden kan du finde produkter, der er omfattet af kategorien pesticider.</p>\
        <p>Her findes bl.a. sager vedrørende forhandling af herbicider, fungicider og insekticider \
        efter udløbet godkendelse, forhandling af ikke-dansk registrerede pesticider, ukorrekt \
        mærkning, ukorrekt markedsføring, ulovlig import og meget mere.</p>\
        <p>Du vil kunne finde produkter fra sager, hvor Kemikalieinspektionen har givet en såkaldt \
        indskærpelse, et påbud eller et forbud til en forhandler, importør eller producent.</p>\
        <p>Produkterne kan derfor være både mangelfulde i forhold til lovkrav og eventuelt udgøre \
        en risiko for dig som forbruger, miljøet eller lignende. Det vil fremgå ud fra det \
        enkelte produkt, hvordan du skal forholde dig som forbruger, hvis du har købt det pågældende \
        produkt.</p>",
      },
      {
        category: "gødning",
        fileName: "Gødning.jpg",
        description:
          "<p>Her på siden kan du finde produkter, der er omfattet af kategorien gødning.</p>\
        <p>Her findes bl.a. sager vedrørende for højt indhold af cadmium i fosforholdigt gødning \
        og ulovlig anprisning.</p>\
        <p>Du vil kunne finde produkter fra sager, hvor Kemikalieinspektionen har givet en såkaldt \
        indskærpelse, et påbud eller et forbud til en forhandler, importør eller producent.</p>\
        <p>Produkterne kan derfor være både mangelfulde i forhold til lovkrav og eventuelt udgøre \
        en risiko for dig som forbruger, miljøet eller lignende. Det vil fremgå ud fra det \
        enkelte produkt, hvordan du skal forholde dig som forbruger, hvis du har købt det pågældende \
        produkt.</p>",
      },
      {
        category: "accessories",
        fileName: "Tøj,-Sko-og-Acessories.jpg",
        description:
          "<p>Her på siden kan du finde produkter, der er omfattet af kategorien tøj, sko og accessories.</p>\
        <p>Du vil fx kunne finde produkter som bukser, trøjer, undertøj, overtøj, stilletter, gummisko, \
        vanter, halstørklæder, ure, ringe, halskæder, brocher, pandebånd og meget mere.</p>\
        <p>Du vil kunne finde produkter fra sager, hvor Kemikalieinspektionen har givet en såkaldt \
        indskærpelse, et påbud eller et forbud til en forhandler, importør eller producent.</p>\
        <p>Produkterne kan derfor være både mangelfulde i forhold til lovkrav og eventuelt udgøre \
        en risiko for dig som forbruger, miljøet eller lignende. Det vil fremgå ud fra det \
        enkelte produkt, hvordan du skal forholde dig som forbruger, hvis du har købt det pågældende \
        produkt.</p>",
      },
      {
        category: "gasser",
        fileName: "Gasser-Klimagasser-og-Spraydåser.jpg",
        description:
          "<p>Her på siden kan du finde produkter, der er omfattet af kategorien gasser: klimagasser og spraydåser.</p>\
        <p>Du vil fx kunne finde produkter som imprægneringssprays, duftfriskere, rengørings-sprayflasker, hårlak, fluesprays, \
        lightergas, naturlige kølemidler, HFC-, CFC-, og PFC-gasser, svovlhexaflourid og meget mere.</p>\
        <p>Bemærk i den forbindelse, at F-gasser (HFC-, CFC-, & PFC-gasser samt svovlhexaflourid) er stærkt reguleret for at \
        beskytte imod global opvarmning, og man kan ved import til Danmark derfor opleve, at ens forsendelse bliver \
        tilbageholdt og i sidste ende beslaglagt, hvis produktet ikke overholder reglerne.</p>\
        <p>Du vil kunne finde produkter fra sager, hvor Kemikalieinspektionen har givet en såkaldt \
        indskærpelse, et påbud eller et forbud til en forhandler, importør eller producent.</p>\
        <p>Produkterne kan derfor være både mangelfulde i forhold til lovkrav og eventuelt udgøre \
        en risiko for dig som forbruger, miljøet eller lignende. Det vil fremgå ud fra det \
        enkelte produkt, hvordan du skal forholde dig som forbruger, hvis du har købt det pågældende \
        produkt.</p>",
      },
      {
        category: "elektronik",
        fileName: "Elektronik,-IT-udstyr-og-Batterier.jpg",
        description:
          "<p>Her på siden kan du finde produkter, der er omfattet af kategorien elektronik, IT-udstyr og batterier.</p>\
        <p>Du vil fx kunne finde produkter som elektrisk værktøj, printplader, SD-kort, mikrofoner, medieafspillere, hårde hvidevarer, \
        skærme, musemåtter, gaming-stole, VR-briller, mobiltelefoner, tablets, bærbare computere, fjernsyn, højtalere, \
        ventilationsudstyr, belysning, køkkenapparater, computer- og mobilbatterier, power-banks, almindelige knapcellebatterier og meget mere.</p>\
        <p>Du vil kunne finde produkter fra sager, hvor Kemikalieinspektionen har givet en såkaldt \
        indskærpelse, et påbud eller et forbud til en forhandler, importør eller producent.</p>\
        <p>Produkterne kan derfor være både mangelfulde i forhold til lovkrav og eventuelt udgøre \
        en risiko for dig som forbruger, miljøet eller lignende. Det vil fremgå ud fra det \
        enkelte produkt, hvordan du skal forholde dig som forbruger, hvis du har købt det pågældende \
        produkt.</p>",
      },
      {
        category: "desinfektion",
        fileName: "Desinfektions--og-Konserveringsmidler.jpg",
        description:
          "<p>Her på siden kan du finde produkter, der er omfattet af kategorien desinfektions- og konserveringsmidler.</p>\
        <p>Her findes produkter til desinfektion af alle typer materialer og udstyr, konservering af alle typer materialer og \
        produkter, bekæmpelse af små og store skadedyr, afskrækning eller tiltrækning af skadedyr, træbeskyttelse, \
        antifouling og balsameringsvæsker (biocider). Biocider er f.eks. håndsprit, fladedesinfektion, myggebalsam \
        (”jungle oil”), myggelys og meget mere.</p>\
        <p>Du vil kunne finde produkter fra sager, hvor Kemikalieinspektionen har givet en såkaldt \
        indskærpelse, et påbud eller et forbud til en forhandler, importør eller producent.</p>\
        <p>Produkterne kan derfor være både mangelfulde i forhold til lovkrav og eventuelt udgøre \
        en risiko for dig som forbruger, miljøet eller lignende. Det vil fremgå ud fra det \
        enkelte produkt, hvordan du skal forholde dig som forbruger, hvis du har købt det pågældende \
        produkt.</p>",
      },
      {
        category: "kosmetik",
        fileName: "Kosmetik-og-personlig-pleje.jpg",
        description:
          "<p>Her på siden kan du finde produkter, der er omfattet af kategorien kosmetik og personlig pleje.</p>\
        <p>Du vil fx kunne finde produkter som foundation, puder, læbestift, neglelak, bruncreme, blegecreme, \
        fugtighedscreme, solcreme, hårvoks, hårlak, ansigtsmasker, skæg- og hårolier, tandpasta, negleolie, \
        shampoo, balsam, neglelim, tandblegemidler, mundskyl, parfumer og meget mere.</p>\
        <p>Du vil kunne finde produkter fra sager, hvor Kemikalieinspektionen har givet en såkaldt \
        indskærpelse, et påbud eller et forbud til en forhandler, importør eller producent.</p>\
        <p>Produkterne kan derfor være både mangelfulde i forhold til lovkrav og eventuelt udgøre \
        en risiko for dig som forbruger, miljøet eller lignende. Det vil fremgå ud fra det \
        enkelte produkt, hvordan du skal forholde dig som forbruger, hvis du har købt det pågældende \
        produkt.</p>",
      },
      {
        category: "gifte",
        fileName: "Kemiske-Blandinger-og-Gifte.jpg",
        description:
          "<p>Her på siden kan du finde produkter, der er omfattet af kategorien kemiske blandinger og gifte.</p>\
        <p>Siden vedrør sig særligt overtrædelser af CLP (klassificering, mærkning og emballering af kemiske stoffer og \
        blandinger), PIC (eksport af kemikalier) og POP (persistente organske miljøgifte) reguleringen. \
        Her er også omfattet gifte til erhvervsmæssig brug.</p>\
        <p>Siden omfatter de produkter, der i lovens definition er kemiske blandinger (fx isolationsmateriale og maling), \
        men som man ikke nødvendigvis ville opfatte sådan som forbruger.</p>\
        <p>Du vil kunne finde produkter fra sager, hvor Kemikalieinspektionen har givet en såkaldt \
        indskærpelse, et påbud eller et forbud til en forhandler, importør eller producent.</p>\
        <p>Produkterne kan derfor være både mangelfulde i forhold til lovkrav og eventuelt udgøre \
        en risiko for dig som forbruger, miljøet eller lignende. Det vil fremgå ud fra det \
        enkelte produkt, hvordan du skal forholde dig som forbruger, hvis du har købt det pågældende \
        produkt.</p>",
      },
      {
        category: "legetøj",
        fileName: "Legetøj-og-Børneprodukter.jpg",
        description:
          "<p>Her på siden kan du finde produkter, der er omfattet af kategorien legetøj og børneprodukter.</p>\
        <p>Du vil fx kunne finde produkter som dukker, bamser, plastik-bondegårdsdyr, konstruktionslegetøj, \
        indlæringslegetøj, legetøjsbiler, legemad, fidgettoys, magnetlegetøj, sandkasselegetøj, kælke, \
        fodbolde, mål, ketcher, badmintonnet, spil, babylegetøj, bleer, sutter, børnebestik, barnevogne, \
        børnemøbler, puslepuder, autostole, legetæpper og meget mere.</p>\
        <p>Du vil kunne finde produkter fra sager, hvor Kemikalieinspektionen har givet en såkaldt \
        indskærpelse, et påbud eller et forbud til en forhandler, importør eller producent.</p>\
        <p>Produkterne kan derfor være både mangelfulde i forhold til lovkrav og eventuelt udgøre \
        en risiko for dig som forbruger, miljøet eller lignende. Det vil fremgå ud fra det \
        enkelte produkt, hvordan du skal forholde dig som forbruger, hvis du har købt det pågældende \
        produkt.</p>",
      },
      {
        category: "skadedyr",
        fileName: "Skadedyrsbekæmpelse.jpg",
        description:
          "<p>Her på siden kan du finde produkter, der er omfattet af kategorien skadedyrsbekæmpelse.</p>\
        <p>Her findes sager vedrørende reglerne omkring bekæmpelse af bl.a. rotter, mus, muldvarpe, mosegrise, \
        lopper (er en del af biocidområdet - \
        <a href='https://mst.dk/kemi/biocider/brancher/skadedyrsbekaempelse/'>https://mst.dk/kemi/biocider/brancher/skadedyrsbekaempelse/</a>\
        ) og meget mere.</p>\
        <p>Du vil kunne finde produkter fra sager, hvor Kemikalieinspektionen har givet en såkaldt \
        indskærpelse, et påbud eller et forbud til en forhandler, importør eller producent.</p>\
        <p>Produkterne kan derfor være både mangelfulde i forhold til lovkrav og eventuelt udgøre \
        en risiko for dig som forbruger, miljøet eller lignende. Det vil fremgå ud fra det \
        enkelte produkt, hvordan du skal forholde dig som forbruger, hvis du har købt det pågældende \
        produkt.</p>",
      },
      {
        category: "rengøring",
        fileName: "Vaske-og-Rengøringsmidler.jpg",
        description:
          "<p>Her på siden kan du finde produkter, der er omfattet af kategorien vaske- og rengøringsmidler.</p>\
        <p>Du vil fx kunne finde produkter som vaskepulver, pletfjerner, skyllemiddel, vaskenødder, vinduesrens, \
        opvaskesæbe, opvaskesvampe med midler/sæber i, gulvvaskemidler, murrens, tag- og fliserens, afsyring, \
        citronsyre, træolie, grundrens, rodalon, opvasketabs, toiletrens og -blok, kalkfjerner, \
        rengøringssprayflasker og meget mere.</p>\
        <p>Du vil kunne finde produkter fra sager, hvor Kemikalieinspektionen har givet en såkaldt \
        indskærpelse, et påbud eller et forbud til en forhandler, importør eller producent.</p>\
        <p>Produkterne kan derfor være både mangelfulde i forhold til lovkrav og eventuelt udgøre \
        en risiko for dig som forbruger, miljøet eller lignende. Det vil fremgå ud fra det \
        enkelte produkt, hvordan du skal forholde dig som forbruger, hvis du har købt det pågældende \
        produkt.</p>",
      },
      {
        category: "forbrugerprodukter",
        fileName: "Andre-forbrugerprodukter.jpg",
        description:
          "<p>Her på siden kan du finde produkter, der er er målrettet dig som forbruger, \
        og som måske ikke er omfattet af de andre kategorier.</p>\
        <p>Du vil fx kunne finde produkter som maling, fugemasse, cement, ikke-elektronisk værktøj, \
        havemøbler, indendørsmøbler, kontorartikler, pyntegenstande, hobbyudstyr, og meget mere.</p>\
        <p>Du vil kunne finde produkter fra sager, hvor Kemikalieinspektionen har givet en såkaldt \
        indskærpelse, et påbud eller et forbud til en forhandler, importør eller producent.</p>\
        <p>Produkterne kan derfor være både mangelfulde i forhold til lovkrav og eventuelt udgøre \
        en risiko for dig som forbruger, miljøet eller lignende. Det vil fremgå ud fra det \
        enkelte produkt, hvordan du skal forholde dig som forbruger, hvis du har købt det pågældende \
        produkt.</p>",
      },
      {
        category: "diverse",
        fileName: "Diverse.jpg",
        description:
          "<p>Her på siden kan du finde produkter, der ikke er omfattet af de andre kategorier, \
        eller som man måske ikke ville omfatte som en del af de andre kategorier.</p>\
        <p>Siden omfatter således de produkter, kemiske stoffer og –blandinger, der ikke sorterer under \
        de andre 12 kategorier, og man vil kunne finde ting, der også falder under Inspektionens \
        tilsynsområde, herunder ulovlig markedsføring.</p>\
        <p>Du vil kunne finde produkter fra sager, hvor Kemikalieinspektionen har givet en såkaldt \
        indskærpelse, et påbud eller et forbud til en forhandler, importør eller producent.</p>\
        <p>Produkterne kan derfor være både mangelfulde i forhold til lovkrav og eventuelt udgøre \
        en risiko for dig som forbruger, miljøet eller lignende. Det vil fremgå ud fra det \
        enkelte produkt, hvordan du skal forholde dig som forbruger, hvis du har købt det pågældende \
        produkt.</p>",
      },
    ],
  };
};

// Define state (allows for reset of state to default state)
const state = getDefaultState();

const mutations = {
  setScrollToList(state, payload) {
    state.scrollToList = payload.scrollToList;
  },
  setPage(state, payload) {
    state.page = payload.page;
  },
  setTotalNumberProducts(state, payload) {
    state.totalNumberProducts = payload.totalNumberProducts;
  },
  setSearchTerm(state, payload) {
    state.searchTerm = payload.searchTerm;
  },
  setReactionFilters(state, payload) {
    state.filtersInput.reactionFilters = payload.reactionFilters;
  },
  setCategoryFilters(state, payload) {
    state.filtersInput.categoryFilters = payload.categoryFilters;
  },
  setReactionNames(state, payload) {
    state.reactionNames = payload.reactionNames;
  },
  setCategoryNames(state, payload) {
    state.categoryNames = payload.categoryNames;
  },
  setProductCards(state, payload) {
    state.productCards = payload.productCards;
  },
  setProductCard(state, payload) {
    state.productCard = payload.productCard;
  },
  addImageUrl(state, payload) {
    state.productImageDict[payload.id] = payload.pictureObject;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
};

export default { namespaced: true, state, mutations, actions };
